<template>
  <div class="about">
    <h1>Impressum</h1>
  </div>
</template>
